import type { UsePlatformThemeHook } from './types';

/**
 * Returns the platform theme the UI is currently built for.
 *
 * Prefer this as a last resort. Branching on the return value spreads
 * platform-specific styling and behaviour into consumers, which is exactly what
 * the themed component layer exists to hide. Before reaching for it, prefer:
 *
 * - a `themed()` component whose per-platform variants encapsulate the difference;
 * - a prop or design token that lets each theme supply its own value.
 *
 * Only use this hook when a genuine divergence cannot be expressed through those
 * patterns.
 */
export const usePlatformTheme: UsePlatformThemeHook = () => 'spark';
